// BI.1.2 Add Linked Account
import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';

import { paperlessBillingApi, linkedAccountsApi } from './api';

// main mixin
import loadingMixin from '../shared/vue/mixins/loading';
import scrollUp from '../shared/vue/mixins/scrollUp';
import formMixin from '../shared/vue/mixins/form';

export default function vueInit() {
  const el = select('[data-vue-app="edit-linked-account"]');
  if (el) {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      el,
      delimiters,
      mixins: [loadingMixin, formMixin, scrollUp],
      data: {
        customerAccountId: '',
        agree: false,
        date: '',
        linkedAccountCount: 0,
        disabledAccountNumber: false,
        modelAccountNumber: '',
        modelAccountNickname: '',
        modelFavoriteThis: false,
        favoriteAccountNickname: {},
        success: false,
        errorMessage: null,
        liveText: '',
        isReady: false,
        modelLdc: '',
        accountStatus: '',
        fromUrl: '',
      },

      mounted() {
        // Find the LDC for the account being edited
        // This will be added to the DOM via back-end.
        if (this.$el.dataset.ldc) {
          this.modelLdc = this.$el.dataset.ldc;
          // now we're ready to mask
          this.isReady = true;
        }

        Vue.nextTick(() => {
          this.loading = true;
          this.customerAccountId = this.$el.dataset.customerAccountNumber;
          this.accountStatus = this.$el.dataset.customerAccountStatus;
          this.fromUrl = this.$el.dataset.fromUrl;

          if (window.accountData) {
            // We're in Fabricator, so use the mocked account data
            this.loading = false;
            if (window.accountData.linkedAccounts) {
              this.linkedAccountCount = window.accountData.linkedAccounts.length;
              this.displayFavoriteAccount(window.accountData.linkedAccounts);
              this.populateFormForSelectedAccount(window.accountData.linkedAccounts);
            }
          } else {
            linkedAccountsApi.getLinkedAccounts()
              .then((linkedAccounts) => {
                this.loading = false;
                this.linkedAccountCount = linkedAccounts.linkedAccounts.length;
                this.displayFavoriteAccount(linkedAccounts.linkedAccounts);
                this.populateFormForSelectedAccount(linkedAccounts.linkedAccounts);
              })
              .catch(this.handleApiError)
          }
        });
      },

      created() {
        Event.$on('A11yDialogConfirm:confirm-account-removal', () => {
          this.loading = true;
          linkedAccountsApi.deleteLinkedAccount(this.customerAccountId)
            .then(() => {
              window.location.href = `/account/manage?deleted=true&account=${this.customerAccountId}`;
            })
            .catch(this.handleApiError);
        });
        Event.$on('UpdateEBillEmail', (request) => {
          if (request && request.paperlessEmail) {
            this.enrollInPaperlessBilling(request.paperlessEmail);
          }
        });
      },

      methods: {
        handleApiError(err) { // eslint-disable-line no-unused-vars
          this.loading = false;
          this.success = false;
          this.scrollUp();
        },
        displayFavoriteAccount(linkedAccounts) {
          const starredAccounts = linkedAccounts.filter(a => a.starred);
          if (starredAccounts.length) {
            this.favoriteAccountNickname = starredAccounts[0].linkedAccountNickname;
          }
        },

        populateFormForSelectedAccount(linkedAccounts) {
          const selectedAccounts = linkedAccounts.filter(a => a.customerAccountId === this.customerAccountId);
          if (selectedAccounts.length) {
            this.modelLdc = selectedAccounts[0].ldc;
            this.modelAccountNumber = selectedAccounts[0].customerAccountId;
            this.modelAccountNickname = selectedAccounts[0].linkedAccountNickname;
            this.modelFavoriteThis = selectedAccounts[0].starred;
          }
        },

        postFormContents() {
          const requestData = this.buildRequestData();
          linkedAccountsApi.updateAccountProfile(this.customerAccountId, requestData)
            .then(() => {
              this.loading = false;
              this.success = true;
              if (this.modelFavoriteThis) {
                this.favoriteAccountNickname = this.modelAccountNickname;
              }
              linkedAccountsApi.updateFavoriteAccount(this.customerAccountId, this.accountStatus, this.modelFavoriteThis)
                .then(() => {
                  if (this.fromUrl !== null && this.fromUrl === "ViewAccount") {
                    window.location.href = "/account/manage?updated=true&fromUrl=true";
                  } else {
                    window.location.href = "/account/manage?updated=true";
                  }
                })
                .catch(() => {
                  window.location.href = "/account/manage?updated=true";
                });
            })
            .catch(this.handleApiError);
        },

        buildRequestData() {
          const requestData = {
            accountNickname: this.modelAccountNickname,
            starred: this.modelFavoriteThis,
          };
          return requestData;
        },

        enrollInPaperlessBilling(paperlessEmail) {
          if (window.fabricator) {
            setTimeout(() => {
              Event.$emit('UpdateEBillEmail:callback', true);
            }, 500);
          } else {
            window.ldcCode = this.modelLdc;
            paperlessBillingApi.enrollInCAPaperlessBilling(this.customerAccountId, paperlessEmail)
              .then(() => {
                Event.$emit('UpdateEBillEmail:callback', true);
              })
              .catch(() => {
                Event.$emit('UpdateEBillEmail:callback', false);
                this.handleApiError();
              });
          }
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/editLinkedAccount.js